import { render } from "./blank-page.vue?vue&type=template&id=3be1b47d&scoped=true"
import script from "./blank-page.vue?vue&type=script&lang=js"
export * from "./blank-page.vue?vue&type=script&lang=js"

import "./blank-page.vue?vue&type=style&index=0&id=3be1b47d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be1b47d"]])

export default __exports__